import { MESSAGEORDER_TYPES } from 'src/constants/constants';
import React from 'react';
import { connect } from 'react-redux';
import MessagesPres from '../Presentation/MessagesPres';
import { fetchMessages } from 'src/services/newdashboard';

class MessagesContainer extends React.Component {
  state = {
    messagesResponse: null,
  };
  componentDidMount() {
    let { caseId } = this.props;
    if (caseId) {
      this.setState({ messagesResponse: null });
      fetchMessages(null, 2, { caseId: caseId, sortDirection: MESSAGEORDER_TYPES.DESC, filter: true, IsDashboard: true }).then(response => {
        this.setState({ messagesResponse: response });
      });
    }
  }
  componentWillUnmount() {}
  render() {
    return (
      <MessagesPres
        caseId={this.props.caseId}
        caseNumber={this.props.caseNumber}
        data={this.state.messagesResponse}
        history={this.props.history}
      />
    );
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(MessagesContainer);
